module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "standard-form"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reset
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [(_vm.state === 'company-info') ? _c('company-info', {
    attrs: {
      "default-info": _vm.companyInfo
    },
    on: {
      "saved": _vm.onSubmit
    }
  }) : _vm._e(), (_vm.state === 'gdpr-consent') ? _c('gdpr-consent', {
    on: {
      "seen": _vm.onSubmit
    }
  }) : _vm._e(), (_vm.state === 'app-consent') ? _c('app-consent', {
    attrs: {
      "code": _vm.code,
      "app": _vm.app
    }
  }) : _vm._e(), (_vm.state === 'persona-capture') ? _c('persona-capture', {
    attrs: {
      "code": _vm.code,
      "app": _vm.app
    },
    on: {
      "saved": _vm.onSubmit
    }
  }) : _vm._e(), (_vm.state === 'select-account') ? _c('div', {
    staticClass: "login-form"
  }, [_c('account-list', {
    attrs: {
      "accounts": _vm.accounts
    },
    on: {
      "account-selected": _vm.onAccountSelected
    }
  }), _c('div', {
    staticClass: "w-page-footer w-page-footer--mb"
  }, [_c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Return to login")])])])], 1) : _vm._e(), (_vm.state === 'app-success') ? _c('div', {
    staticClass: "app-success"
  }, [_c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("Login successful")]), _c('div', {
    staticClass: "auth-token",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.code))])])])]) : _vm._e(), (_vm.state === 'normal') ? _c('div', {
    staticClass: "login-form"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title,
      "error": _vm.formError
    }
  }), (_vm.allowStandardLogin) ? _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [(_vm.state === 'normal') ? _c('div', {
    staticClass: "login-fields"
  }, [_c('div', {
    staticClass: "w-login-form__row w-login-form__row--email"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "loginemail"
    }
  }, [_vm._v("Email address")]), ((_vm.loginType === 'account' || _vm.password === 'xxx' ? 'text' : 'email') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "loginemail",
      "placehoder": "",
      "autocomplete": _vm.isEnterprise ? 'off' : 'username',
      "required": "required",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.email) ? _vm._i(_vm.email, null) > -1 : (_vm.email)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.email = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.email = $$c
        }
      }
    }
  }) : ((_vm.loginType === 'account' || _vm.password === 'xxx' ? 'text' : 'email') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "loginemail",
      "placehoder": "",
      "autocomplete": _vm.isEnterprise ? 'off' : 'username',
      "required": "required",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.email, null)
    },
    on: {
      "change": function($event) {
        _vm.email = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "loginemail",
      "placehoder": "",
      "autocomplete": _vm.isEnterprise ? 'off' : 'username',
      "required": "required",
      "type": _vm.loginType === 'account' || _vm.password === 'xxx' ? 'text' : 'email'
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--password"
  }, [_c('password-input', {
    attrs: {
      "label": "Password",
      "autocomplete": _vm.isEnterprise ? 'off' : 'current-password',
      "required": "required"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), (_vm.showRememberMe || !_vm.inAppLogin) ? _c('div', {
    staticClass: "w-login-form__row w-login-form__row--remember"
  }, [(_vm.showRememberMe) ? _c('label', {
    staticClass: "w-checkbox",
    attrs: {
      "for": "rememberMe"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    staticClass: "w-checkbox__input",
    attrs: {
      "id": "rememberMe",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "w-checkbox__label"
  }, [_vm._v("Remember me")])]) : _vm._e(), (!_vm.inAppLogin) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.forgotPasswordLink,
        query: Object.assign(_vm.$route.query, {
          email: _vm.email
        })
      }
    }
  }, [_vm._v("Forgot password?")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._m(0)]) : _vm._e(), _c('div', {
    staticClass: "w-page-footer"
  }, [(_vm.showGoogleSSO) ? _c('a', {
    staticClass: "w-button",
    attrs: {
      "href": _vm.googleSSOURL
    },
    on: {
      "click": _vm.onClickGoogleSSO
    }
  }, [_vm._m(1), _c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in with Google")])]) : _vm._e(), (_vm.showSAML) ? _c('a', {
    staticClass: "w-button w-button--link",
    on: {
      "click": _vm.initSAML
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Single Sign On (SSO)")])]) : _vm._e(), (_vm.startText) ? _c('div', {
    staticClass: "w-page-footer__start-text",
    domProps: {
      "innerHTML": _vm._s(_vm.startText)
    }
  }) : _vm._e()])], 1) : _vm._e(), (_vm.state === '2fa') ? _c('div', {
    staticClass: "login-form__two-factor-auth"
  }, [_c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('page-header', {
    attrs: {
      "title": "Two Factor Authentication",
      "subTitle": "Please enter your six-digit number from your authenticator app.",
      "error": _vm.formError,
      "hideable": false
    }
  }), _c('div', {
    staticClass: "w-auth-code w-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.twoFactorPasscode),
      expression: "twoFactorPasscode"
    }],
    staticClass: "w-auth-code__input w-input__input",
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "pattern": "[0-9]*",
      "maxlength": "8",
      "placeholder": "Authentication Passcode",
      "autocomplete": "off",
      "required": "required"
    },
    domProps: {
      "value": (_vm.twoFactorPasscode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.twoFactorPasscode = $event.target.value
      }
    }
  })]), _vm._m(2), _c('div', {
    staticClass: "w-page-footer"
  }, [_c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Cancel")])])])], 1)]) : _vm._e(), (_vm.state === '2fa-setup') ? _c('tfa-setup', {
    attrs: {
      "forced": _vm.forced
    },
    on: {
      "cancel": _vm.reset,
      "setup-complete": _vm.onSubmit
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "w-button__icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/google-logo-mini.png"),
      "alt": "Google",
      "width": "16",
      "height": "16"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a586067","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Login/StandardForm/StandardForm.vue
// module id = 598
// module chunks = 1